export const INTAKE_MODES = {
  BOT_TRIAGE: 'botTriage',
  FORM: 'form',
  IMMEDIATE: 'immediate',
} as const;

export type IntakeMode = (typeof INTAKE_MODES)[keyof typeof INTAKE_MODES];

export const INTAKE_MODE_LABELS = {
  [INTAKE_MODES.IMMEDIATE]: 'Create ticket immediately',
  [INTAKE_MODES.BOT_TRIAGE]: 'Loop in AI Agent to triage request',
  [INTAKE_MODES.FORM]: 'Present ticket form before creating ticket',
};

export const AGENT_HANDOFF_MODES = {
  AUTOMATIC: 'automatic',
  PROMPT: 'prompt',
} as const;

export type AgentHandoffMode = (typeof AGENT_HANDOFF_MODES)[keyof typeof AGENT_HANDOFF_MODES];

export const AGENT_HANDOFF_MODE_LABELS = {
  [AGENT_HANDOFF_MODES.AUTOMATIC]: 'Automatic ticket creation & handoff',
  [AGENT_HANDOFF_MODES.PROMPT]: 'Show button to create ticket',
};

export interface IntakeSettings {
  bot?: {
    enabled?: boolean;
    maxResponses?: number | null;
    handoffMode?: AgentHandoffMode;
  };
  form?: {
    enabled?: boolean;
  };
}

export const CHANNEL_TYPES = {
  SLACK: 'slack',
  EMAIL: 'email',
  WIDGET: 'widget',
  MICROSOFT_TEAMS: 'microsoft-teams',
  JSM: 'jsm',
} as const;

export type ChannelType = (typeof CHANNEL_TYPES)[keyof typeof CHANNEL_TYPES];
